import React from 'react';
import { Layout, Row, Col } from 'antd';
import {
  EnvironmentOutlined,
  WhatsAppOutlined,
  InstagramOutlined,
  YoutubeOutlined,
  FacebookOutlined,
  GlobalOutlined,
} from '@ant-design/icons';
import './Footer.css';

const { Footer } = Layout;

const AppFooter = () => {
  const currentYear = new Date().getFullYear();

  return (
    <Footer className="app-footer">
      <div className="footer-content">
        <Row gutter={[32, 32]}>
          {/* Kolom 1: Tentang */}
          <Col xs={24} sm={12} md={8}>
            <div className="footer-column">
              <h3 className="footer-title">MAN 1 Gresik</h3>
              <p className="footer-description">
                Madrasah Aliyah Negeri 1 Gresik menuju MAN 4.0 Berbasis Teknologi Digital.
                Berkomitmen menyelenggarakan pendidikan Islam berkualitas, unggul, dan berdaya saing global.
              </p>
            </div>
          </Col>

          {/* Kolom 2: Layanan */}
          <Col xs={24} sm={12} md={8}>
            <div className="footer-column">
              <h3 className="footer-title">Layanan & Portal</h3>
              <ul className="footer-links">
                <li>
                  <a href="https://rdm.kemenag.go.id/" target="_blank" rel="noopener noreferrer">
                    Rapor Digital Madrasah (RDM)
                  </a>
                </li>
                <li>
                  <a href="https://ruangpintar.man1gresik.sch.id/" target="_blank" rel="noopener noreferrer">
                    E-Learning Madrasah
                  </a>
                </li>
                <li>
                  <a href="http://digilib.man1gresik.sch.id/" target="_blank" rel="noopener noreferrer">
                    Digilib Madrasah
                  </a>
                </li>
                <li>
                  <a href={process.env.REACT_APP_PPDB_WEB_URL || '#'} target="_blank" rel="noopener noreferrer">
                    Portal PPDB Online
                  </a>
                </li>
                <li>
                  <a href="https://man1gresik.sch.id/" target="_blank" rel="noopener noreferrer">
                    Website Utama MAN 1 Gresik
                  </a>
                </li>
              </ul>
            </div>
          </Col>

          {/* Kolom 3: Kontak */}
          <Col xs={24} sm={24} md={8}>
            <div className="footer-column">
              <h3 className="footer-title">Kontak & Alamat</h3>
              <ul className="footer-contact">
                <li>
                  <EnvironmentOutlined className="contact-icon" />
                  <span>
                    Jl. Raya Bungah No. 63 Gresik{' '}
                    <a
                      href="https://maps.google.com/?q=MAN+1+Gresik"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="maps-link"
                    >
                      (Lihat Google Maps)
                    </a>
                  </span>
                </li>
                <li>
                  <WhatsAppOutlined className="contact-icon" />
                  <a
                    href="https://wa.me/6281234567890"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    WhatsApp Helpdesk
                  </a>
                </li>
                <li>
                  <GlobalOutlined className="contact-icon" />
                  <a
                    href="https://man1gresik.sch.id"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    man1gresik.sch.id
                  </a>
                </li>
              </ul>
              <div className="footer-socials">
                <a
                  href="https://instagram.com/man1gresik"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Instagram"
                >
                  <InstagramOutlined />
                </a>
                <a
                  href="https://youtube.com/@man1gresik"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="YouTube"
                >
                  <YoutubeOutlined />
                </a>
                <a
                  href="https://facebook.com/man1gresik"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Facebook"
                >
                  <FacebookOutlined />
                </a>
              </div>
            </div>
          </Col>
        </Row>
      </div>
      <div className="footer-bottom">
        &copy; MAN 1 Gresik {currentYear} All Rights Reserved
      </div>
    </Footer>
  );
};

export default AppFooter;